import { Column, Container } from "@/components/ui/layout";
import { View } from "@/components/ui";
import type { ServiceName } from "@/types/service";
import { SelectServiceNavigation } from "./select-service-navigation";
import { getPlatform } from "@/lib/utils";
import { SelectAirconService } from "./services/select-aircon-service";
import { WebBackButtonHeader } from "@/components/shared/back-button";
import { WhatsappSupportBanner } from "@/components/shared/whatsapp-support-banner";
import { onChatSales } from "@/lib/chat-sales";
import { generateBookingChatSalesMessage } from "@/lib/chat-sales";

const SelectBookingService = ({ name }: { name: ServiceName }) => {
  if (name === "aircon-service") return <SelectAirconService />;
};

export const SelectService = ({ name }: { name: ServiceName }) => {
  const platform = getPlatform();

  return (
    <View className="pb-4">
      <Container>
        <Column desktop="8">
          <WebBackButtonHeader title="Select Service" />
          <SelectBookingService name={name} />
        </Column>

        <Column desktop="4">
          {platform === "web" && (
            <View className="flex flex-col gap-4 py-4 md:sticky md:top-14">
              <SelectServiceNavigation name={name} />
              <View className="hidden md:block">
                <WhatsappSupportBanner
                  onClick={() =>
                    onChatSales(true, generateBookingChatSalesMessage(name))
                  }
                />
              </View>
            </View>
          )}
        </Column>
      </Container>
    </View>
  );
};
